<script>
  import { t } from 'precompile-intl-runtime';

  function reload() {
    location.reload();
  }
</script>

<div class="container">
  <div class="reload-dialog">
    <h1>{$t('reloadDialog.header')}</h1>
    <p>{$t('reloadDialog.message')}</p>
    <button on:click={() => reload()}>Reload page</button>
  </div>
</div>

<style>
  .container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    z-index: 10000;

    background-color: rgba(0, 0, 0, 0.8);

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .reload-dialog {
    background-color: var(--color-1);
    color: var(--color-2);
    padding: 5em 10em;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  span {
    font-size: 16px;
  }

  button {
    padding: 8px;
  }
</style>
